import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {EditService} from '../shared/services/editService/edit.service';
import {FormBuilder, Validators} from '@angular/forms';
import {FormItemsService} from '../shared/services/databaseServices/formItems/form-items.service';
import {FormItemDateTypeService} from '../shared/services/databaseServices/formItemDateTypeService/form-item-date-type.service';
import {DateType} from '../shared/classes/DateType';
import {faSave, faTrash} from '@fortawesome/free-solid-svg-icons';
import {FormItem} from '../shared/classes/FormItem';

@Component({
  selector: 'app-form-items-details',
  templateUrl: './form-items-details.component.html',
  styleUrls: ['./form-items-details.component.css']
})
export class FormItemsDetailsComponent implements OnInit {

  id = undefined;
  isNew = false;
  dateTypes: DateType[] = undefined;
  faSave = faSave;
  faTrash = faTrash;
  formItemId = undefined;

  plusButton = true;
  editButton = false;

  createTooltip = 'raceDetailPage.startFeeTab.saveToolTip';
  deleteTooltip = 'raceDetailPage.startFeeTab.deleteToolTip';
  addTooltip = 'raceDetailPage.startFeeTab.addToolTip';

  private static NEW_ID = 'new';

  formItem = this.formBuilder.group({
    visibleText: ['', [Validators.required]],
    type: ['', [Validators.required]],
    visibleDefault: [false, []],
    requiredDefault: [false, []],
  });

  enumForm = this.formBuilder.group({
    enumName: ['', [Validators.required]]
  });

  header = [
    {
      defName: 'enumName',
      translation: 'settingPage.formItems.tab.enumName',
      elem: 'enumName'
    }
  ];

  displayedColumns: string[] = ['enumName'];

  enumList: string[] = undefined;
  enumListForTab: any[] = undefined;


  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private editService: EditService,
              private formBuilder: FormBuilder,
              private formItemsService: FormItemsService,
              private formItemDateType: FormItemDateTypeService) { }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.isNew = this.id === FormItemsDetailsComponent.NEW_ID;
    this.loadType();
    if(this.isNew){

    } else {
      this.formItemsService.getOneFormItem(this.id).then( data => {
        this.formItem.get('visibleText').disable();
        this.formItemId = data.id;
        this.formItem.patchValue( {
          visibleText: data.data().visibleText,
          type: data.data().type.id,
          visibleDefault: data.data().visibleDefault,
          requiredDefault: data.data().requiredDefault
        });

        if(data.data().type.id === 'enum'){
          this.loadEnum(this.formItemId);
        }
      });
    }
  }

  loadType(){
    this.formItemDateType.getFormItemDateType().then( data => {
     this.dateTypes = [];
     data.forEach( item => {
       const dateType: DateType = new DateType();
       dateType.key = item.id;
       dateType.type = item.data().type;
       this.dateTypes.push(dateType);
     });
    });
  }

  loadEnum(id){
    this.formItemsService.getEnum(id).then(data => {
      this.enumList = data.data().type;
      this.enumForTable();
    }).catch( err => {
      console.log(err);
    })
  }

  create(){
    const formItem: FormItem = new FormItem();
    formItem.visibleText = this.formItem.get('visibleText').value;
    formItem.visibleDefault = this.formItem.get('visibleDefault').value;
    formItem.requiredDefault = this.formItem.get('requiredDefault').value;
    formItem.type = this.formItem.get('type').value;
    this.formItemsService.create(formItem.visibleText, formItem).then( () => {
      this.router.navigate(['/admin/settings/formItems']);
    }).catch( err => {
      console.dir(err);
    })
  }

  remove(item){
    this.formItemsService.deleteFormItems(item).then(() => {
      this.router.navigate(['/admin/settings/formItems']);
    }).catch(err => {
      console.dir(err);
    });
  }

  isEdit(){
    return this.editService.editable;
  }

  createEnum(item){
    if(this.enumList === undefined){
      this.enumList = [];
    }
    this.enumList.push(this.enumForm.get('enumName').value);
    this.toggleButton();
    this.enumForTable();
  }

  deleteEnum(item){
    this.enumList = this.enumList.filter( i => i !== this.enumForm.get('enumName').value);
    this.toggleButton();
    this.enumForTable();

  }

  addEnum(item){
    this.toggleButton()
  }

  enumForTable(){
    if(this.enumList === undefined){
      this.enumListForTab = undefined;
    } else {
      this.enumListForTab = this.enumList.map(item => {
        const i = {enumName: item};
        return i;
      } );
    }
  }

  private toggleButton(){
    this.editButton = !this.editButton;
    this.plusButton = !this.plusButton;
  }

  editEnum(item){
    this.enumForm.patchValue({enumName: item.enumName});
    this.toggleButton();
  }

}
